module.exports = __webpack_public_path__ + "img/appAsset-brand--GoogleSheets.d0481dc9.svg";